// Shared fallback upcoming-events list. Used by <EventsShowcase/> and
// <UpcomingEventsSection/> whenever /api/events returns nothing, so the
// "UPCOMING EVENTS" countdown (days:hrs:min:sec) always has real future dates
// to tick down to instead of showing empty/"coming soon" cards.
//
// Dates are computed RELATIVE TO NOW (now + N days), so they're guaranteed to
// stay in the future no matter when the page is opened — the countdown is
// always live and never goes stale.

const DAY_MS = 86400000;

// Build an ISO date `days`/`hours` from now (so it always lands in the future).
function fromNow(days, hours = 0) {
  return new Date(Date.now() + days * DAY_MS + hours * 3600000).toISOString();
}

export default function getFallbackEvents() {
  return [
    {
    id: "fallback-fc25",
    title: "eSmaaash Classico — FC 26 Showdown",
    venue: "Smaaash, Lower Parel, Mumbai",
    city: "Mumbai",
    image: "/esmaaash_web/frontend/public/images/FCbanner.jpeg",
    mobileImage: "/esmaaash_web/frontend/public/images/FCbanner.jpeg",
    link: "https://esmaaash.in/esmaaash-classico/register",
    
    // REAL DATE: July 26, 2026 at 6:30 PM
    event_date_raw: "2026-07-26T18:30:00", 
    status: "upcoming"
  },
  {
    id: "fallback-Chessmaster-nexusHyderabad",
    title: "Chess Master Nexus Hyderabad",
    venue: "Nexus Mall, Hyderabad",
    city: "Hyderabad",
    image: "/esmaaash_web/frontend/public/images/chessnexus1.jpg",
    mobileImage: "/esmaaash_web/frontend/public/images/chessnexus.jpg",
    link: "https://esmaaash.in/chessmaster/hyderabad-nexus/register.php",
    
    // REAL DATE: July 19, 2026 at 6:00 PM
    event_date_raw: "2026-07-19T18:00:00", 
    status: "upcoming"
  },{/*
    {
      id: "fallback-fc26-wide",
      title: "eSmaaash Classico — Grand Finals",
      venue: "Smaaash, Lower Parel, Mumbai",
      city: "Mumbai",
      image: "/banners/classico-fc26-desktop.png",
      mobileImage: "/banners/classico-fc26-mobile.png",
      link: "https://esmaaash.in/esmaaash-classico/register",
      date: fromNow(34),
      status: "upcoming",
    },
    {
      id: "fallback-smaaashday",
      title: "Smaaash Day 2026",
      venue: "Smaaash, Multiple Cities",
      city: "Pan India",
      image: "/dummy/dummy-event-1600x900.png",
      mobileImage: "/dummy/dummy-event-800x450.png",
      link: "/events",
      date: fromNow(52),
      status: "upcoming",
    }, */}
  ];
}
